<template>
    <div>
        <Container fluid>
            <div style="font-weight: 600;font-size:28px;">Ваши записи<sup v-if="orders">{{ orders.length }}</sup></div>
            <template v-if="this.$vuetify.breakpoint.smAndDown">
                <div
                    v-for="carHistoryItem in orders"
                    :key="carHistoryItem.id"
                >
                    <OrderHistoryItem :order="carHistoryItem" :car="carState.cars[carHistoryItem.carId]" withCar withoutComment withCancelBtn />
                </div>
            </template>
            <template v-else>
                <!-- isMobile = false -->
                <div class="history-table-header mt-10 d-flex px-6 font-weight-bold">
                    <div class="pr-2" style="width: 12%">Дата и время</div>
                    <div class="px-2" style="width: 20%">Номер документа</div>
                    <div class="px-2" style="width: 20%">Автомобиль</div>
                    <div class="px-2" style="width: 40%">Список услуг</div>
                    <!-- <div class="px-2" style="width: 13%">Цена</div> -->
                    <div class="px-8">1</div>
                </div>
                <div
                    v-for="(carHistoryItem, index) in orders"
                    :key="carHistoryItem.id"
                >
                    <OrderHistoryItem :order="carHistoryItem" :car="carState.cars[carHistoryItem.carId]" withCar withoutComment withCancelBtn/>
                    <v-divider v-if="index !== orders.length - 1" class="mt-2"/>
                </div>
            </template>
        </Container>
        <Container fluid>
            <div style="font-weight: 600;font-size:28px;">История ремонта<sup v-if="carHistory">{{ carHistory.length }}</sup></div>
            <template v-if="this.$vuetify.breakpoint.smAndDown">
                <div
                    v-for="carHistoryItem in carHistory"
                    :key="carHistoryItem.id"
                >
                    <OrderHistoryItem :order="carHistoryItem" :car="carState.cars[carHistoryItem.carId]" withCar />
                </div>
            </template>
            <template v-else>
                <!-- isMobile = false -->
                <div class="history-table-header mt-2 d-flex px-6">
                    <div class="pr-2" style="width: 12%">Дата и время</div>
                    <div class="px-2" style="width: 20%">Номер документа</div>
                    <div class="px-2" style="width: 20%">Автомобиль</div>
                    <div class="px-2" style="width: 40%">Список услуг</div>
                    <!-- <div class="px-2" style="width: 13%">Цена</div> -->
                    <div class="px-8"></div>
                </div>
                <div
                    v-for="(carHistoryItem, index) in carHistory"
                    :key="carHistoryItem.id"
                >
                    <OrderHistoryItem :order="carHistoryItem" :car="carState.cars[carHistoryItem.carId]" withCar/>
                    <v-divider v-if="index !== carHistory.length - 1" class="mt-2"/>
                </div>
            </template>
        </Container>
    </div>
</template>

<script>
    import { mapGetters, mapState } from 'vuex'

    import Container from '@/components/Vuetify/Container'
    import OrderHistoryItem from '@/components/app/personal/order/OrderHistoryItem'

    export default {
        name: 'HistoryScreen',

        components: {
            Container,
            OrderHistoryItem,
        },

        computed: {
            ...mapState('car', {
                carState: state => state,
            }),

            ...mapGetters({
                carHistory: 'carHistory/getCarHistory',
                orders: 'order/getOrders',
            }),
        },

        mounted() {
            this.$store.dispatch('car/fetch')
            this.$store.dispatch('order/fetch')
            this.$store.dispatch('carHistory/fetch')
        },
    }
</script>

<style scoped>
    .history-table-header {
        background-color: #F3F4F4;
        padding: 12px 0 12px 0;
        font-weight: 600;
    }
</style>
